import React from "react";
import { Link } from "react-router-dom";

interface BreadcrumbLink {
  label: string;
  href: string;
  isActive: boolean;
}

interface BreadcrumbProps {
  links: BreadcrumbLink[];
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ links }) => {
  return (
    <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
      <li className="breadcrumb-item me-3">
        <button
          onClick={() => window.history.back()}
          className="btn btn-link text-muted text-hover-primary p-0"
        >
          <i className="fas fa-arrow-left" /> Back
        </button>
      </li>
      {links.map((link, index) => (
        <React.Fragment key={index}>
          <li className={`breadcrumb-item ${link.isActive ? "text-dark fs-5" : "text-muted"}`}>
            {link.isActive ? (
              <span>{link.label}</span>
            ) : (
              <Link to={link.href} className='text-muted text-hover-primary fs-5'>
                {link.label}
              </Link>

            )}
          </li>
          {index < links.length - 1 && (
            <li className="breadcrumb-item">
              <span className="bullet bg-gray-400 w-5px h-2px" />
            </li>
          )}
        </React.Fragment>
      ))}
    </ul>
  );
};

export default Breadcrumb;